import * as actions from "./inventories.actions";
import * as types from "./inventories.actionTypes";
import { ActionType, createReducer } from "typesafe-actions";
import { InventoryReducerType } from "./types";

export type InventoryActions = ActionType<typeof actions>;

export const initialState: InventoryReducerType = {
  error: null,
  inventories: [],
  isLoading: false,
  createdInventory: null,
  selectedInventory: null,
  meta: {
    total: 0,
    per_page: 0,
    last_page: 0,
    current_page: 0,
  }
};

export const InventoryReducer = createReducer<
  InventoryReducerType,
  InventoryActions
>(initialState)
  .handleAction(actions.getInventoryAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: ''
  }))
  .handleAction(actions.getInventoryAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    inventories: action.payload.data,
    meta: action.payload.meta
  }))
  .handleAction(actions.getInventoryAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))
  .handleAction(actions.selectInventoryAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    createdInventory: null,
    selectedInventory: null,
    redirectQueue: ''
  }))
  .handleAction(actions.selectInventoryAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    selectedInventory: action.payload.data,
  }))
  .handleAction(actions.selectInventoryAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    selectedInventory: null,
    error: action.payload,
  }))
  .handleAction(actions.updateInventoryAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: ''
  }))
  .handleAction(actions.updateInventoryAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    createdInventory: action.payload.data,
  }))
  .handleAction(actions.updateInventoryAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))
  .handleAction(actions.createInventoryAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: ''
  }))
  .handleAction(actions.createInventoryAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    createdInventory: action.payload.data
  }))
  .handleAction(actions.createInventoryAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))
  .handleAction(types.SET_ERROR as any, (state, action) => ({
    ...state,
    error: action.payload.value
  }))
  .handleAction(types.RESET_STATE as any, (state, action) => ({
    ...state,
    error: null,
    createdInventory: null,
    selectedInventory: null
  }))
